"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ordersStore = exports.FileFormat = void 0;
const api_1 = require("client/api");
const print_labels_1 = require("client/modules/labels/print-labels");
const mobx_1 = require("mobx");
const moment = require("moment");
const dashboard_1 = require("shared/dashboard");
const order_1 = require("shared/order");
const store_1 = require("./modules/orders-detail/tabs/payment/store"); //D-002.611
var FileFormat;
(function (FileFormat) {
    FileFormat["ChiroTouch"] = "Chiro Touch";
    FileFormat["Eclipse"] = "Eclipse";
    FileFormat["Vericle"] = "Vericle";
    FileFormat["NexgenHealthFusion"] = "Nexgen Health Fusion";
    FileFormat["AdvancedMD"] = "Advanced MD";
    FileFormat["Meditouch"] = "Meditouch";
    FileFormat["PracticeSuite"] = "Practice Suite";
    FileFormat["BillingVision"] = "Billing Vision";
    FileFormat["BillingPrecision"] = "Billing Precision";
    FileFormat["Medisoft"] = "Medisoft";
    FileFormat["MacPractice"] = "Mac Practice";
})(FileFormat = exports.FileFormat || (exports.FileFormat = {}));
class OrdersStore {
    constructor() {
        this.erxDataFieldMap = {};
        this.count = {};
        this.order = {};
        this.orders = {};
        this.pendingOrders = {}; // D-002_new
        this.bulkOrders = {}; // B-106
        this.pads = { value: [] };
        this.mobilePads = { value: [] };
        this.showCompleted = false;
        this.paymentToggle = false;
        this.submission = {};
        this.submissionQueueLength = 0;
        this.submitted = false;
        this.submissionInProgress = false;
        this.siteSelected = false;
        this.claimsGroup = { value: [] };
        this.signatureBypassed = { value: [] }; // C-108.7
        this.intentClaims = { value: [] };
        this.claim = {};
        this.financialClaims = [];
        this.financialClaimsDispensed = [];
        this.parsedRows = [];
        this.importedOrders = [];
        this.errorAlert = null;
        this.importColumnsHeader = [];
        this.sampleFirstDataRow = [];
        this.sampleFirst5DataRows = [];
        // print labels observables
        // : IClaim[] ??
        this.selectedClaims = [];
        this.menuOpen = {};
        this.scheduleDateFromRtf = "";
        this.selectedSiteId = "0";
        this.userViewCount = null;
        this.selectedProviderId = "0";
        this.submitAutomation = false;
        this.fileFormat = null;
        // C-045.1
        this.claimOrders = [];
        this.isClaim = false;
        // C-097 Claims
        this.totalProviderPage = 1;
        this.currentPage = 1;
        this.claimsLoading = false;
        this.shouldAutomateSubmission = false;
        // C-097 Claims D-002_new
        this.totalPendingPage = 1;
        this.pendingCurrentPage = 1;
        this.pendingPayableRequestId = 0;
        this.knownHeaderFormats = {
            chiroTouch: ["Time", "Patient", "Purpose of Visit", "Provider", "Contact"],
            eclipse: [],
            vericle: [
                "Appt Time",
                "Appt Type",
                "Physician",
                "Patient",
                "Action",
                "Performed By",
                "Date",
                "Action From",
                "Message",
                "ID"
            ],
            nexgenHealthFusion: ["Date", "Patient Name", "Date of Birth"],
            advancedMD: [
                "Name",
                "Pat ID",
                "SSN",
                "DOB",
                "State",
                "City",
                "Zip",
                "Confidential",
                "Gender",
                "Marital Status",
                "Provider",
                "HW",
                "Appointment Type"
            ],
            meditouch: [
                "Date of Service",
                "Calendar Resource Name",
                "Location Name",
                "Time",
                "Appointment Length",
                "Appointment Type",
                "Patient Name",
                "Account Type",
                "Date of Birth",
                "Gender",
                "Home Phone",
                "Cell Phone",
                "Primary Payer Name",
                "Appointment Status",
                "Check-In Time",
                "Check-Out Time",
                "Co-Pay",
                "Appointment Note",
                "Patient Preferred Phone",
                "Patient Contact Preference",
                "Payment Collected"
            ],
            practiceSuite: [
                "Patient",
                "PC Ref#",
                "MR#",
                "Appointment Date",
                "Appointment Time",
                "Legal Entity",
                "Rendering Provider",
                "Appointment Status"
            ],
            billingVision: [],
            billingPrecision: ["10-Jan", "__EMPTY"],
            medisoft: [],
            macPractice: [
                "Patient Last, First",
                "Date of Birth",
                "Date",
                "Time(Min)",
                "Provider",
                ""
            ]
        };
        this.correctTimeMeridiem = (time) => {
            const timeFormat = "h:mm A";
            const beforeTime = moment("10:00 PM", timeFormat).subtract(1, "day"); /*?*/
            const afterTime = moment("7:00 AM", timeFormat); /*?*/
            let correctedTime = moment(time, timeFormat).format(timeFormat); /*?*/
            const timeMoment = moment(correctedTime, timeFormat); /*?*/
            const shouldBePm = timeMoment.isBetween(beforeTime, afterTime); /*?*/
            if (shouldBePm) {
                correctedTime = moment(correctedTime, timeFormat)
                    .add(12, "hours")
                    .format("h:mm A"); /*?*/
            }
            return correctedTime;
        };
        this.readERXLog = async (id) => {
            const query = { id };
            const result = await api_1.OrderEndpoint.readERXLog.apiCall({ query });
            if (api_1.isError(result)) {
                return { error: result.code };
            }
            return { value: result.erxLogs };
        };
        this.fillInMissingData = (schedules) => schedules.map((schedule) => {
            // console.log('schedules is ', schedules);
            let firstName = "";
            let lastName = "";
            let date = this.scheduleDateFromRtf
                ? moment(this.scheduleDateFromRtf).format("M/D/YY")
                : moment(new Date()).format("M/D/YY");
            let time = "8:00 AM";
            const providerFullName = schedule.PROVIDER_FULL_NAME;
            const fullName = schedule.PATIENT_FULL_NAME;
            const dateTime = this.normalizeDateTime(schedule.DATE_TIME);
            const patientDob = schedule.PATIENT_DOB;
            if (fullName) {
                if (fullName.trim().indexOf(",") !== -1) {
                    const lastFirst = fullName.trim().split(",");
                    firstName = lastFirst[1];
                    lastName = lastFirst[0];
                }
                else if (fullName.trim().indexOf(" ") !== -1) {
                    const firstLast = fullName.trim().split(" ");
                    firstName = firstLast[0];
                    lastName = firstLast[1];
                }
                else {
                    firstName = fullName;
                }
            }
            // Parse provider name
            /*
              LASTNAME, FIRSTNAME
              FIRSTNAME LASTNAME DC
              LASTNAME, FIRSTNAME
              LASTNAME,FIRSTNAME,MD
             */
            const excludeWords = ["DO", "DC ", "MD", "DPM", "NP", "APRN", "PA", "RN"];
            const excludeWordsLowerCased = excludeWords.map((title) => title.toLowerCase());
            let providerFirstName = "";
            let providerLastName = "";
            if (providerFullName) {
                // if fullname contains , assume LASTNAME, FIRSTNAME
                if (providerFullName.includes(",")) {
                    const providerFullNameParsed = providerFullName
                        .split(",")
                        .filter((word) => word.trim().length > 2 ||
                        !excludeWordsLowerCased.includes(word.toLowerCase().trim()))
                        .join(" "); /*?*/
                    const providerNameArray = providerFullNameParsed
                        .split(" ")
                        .filter((word) => word && !word.includes("(")); /*?*/
                    // assume middle name
                    const { length } = providerNameArray;
                    if (length >= 2) {
                        providerFirstName = providerNameArray[length - 1];
                        providerLastName = providerNameArray[0];
                    }
                    providerFirstName;
                    providerLastName;
                }
                else {
                    // assume FIRSTNAME [MIDDLENAME] LASTNAME
                    const providerFullNameParsed = providerFullName.split(" "); /*?*/
                    const { length } = providerFullNameParsed;
                    if (length) {
                        if (length > 2) {
                            providerFirstName = providerFullNameParsed[0];
                            providerLastName = providerFullNameParsed.slice(1).join(" ");
                        }
                        else if (length === 2) {
                            providerFirstName = providerFullNameParsed[0];
                            providerLastName = providerFullNameParsed[length - 1];
                        }
                        else {
                            providerFirstName = providerFullNameParsed[0];
                        }
                    }
                }
            }
            // Assuming dateTime is "MM/DD/YYYY h:mm"
            if (dateTime) {
                const dateTimeSplit = dateTime.trim().split(" ");
                if (dateTimeSplit && dateTimeSplit.length >= 2) {
                    date = dateTimeSplit[0];
                    // time = moment(dateTimeSplit[1], "h:mm A").format("h:mm A");
                    const timeSlice = moment(dateTimeSplit.slice(1), "h:mm A").format("h:mm A");
                    const timeSliceHasMeridiem = moment(timeSlice, "h:mm A", true).isValid();
                    time = timeSliceHasMeridiem
                        ? timeSlice
                        : this.correctTimeMeridiem(timeSlice);
                }
                else if (dateTimeSplit && dateTimeSplit.length === 1) {
                    date = dateTimeSplit[0]; // If length of split array is 1 then set the value of index zero to the date variable
                }
            }
            const scheduleTimeIsValid = moment(schedule.TIME, "h:mm A", true).isValid();
            const timeIsValid = moment(time, "h:mm A", true).isValid();
            const nameRe = /["\(][\w\s]+[\)"]/g;
            return Object.assign(Object.assign({}, schedule), { PATIENT_FIRST_NAME: schedule.PATIENT_FIRST_NAME
                    ? schedule.PATIENT_FIRST_NAME
                    : firstName.trim().replace(nameRe, ""), PATIENT_LAST_NAME: schedule.PATIENT_LAST_NAME
                    ? schedule.PATIENT_LAST_NAME
                    : lastName.trim().replace(nameRe, ""), PATIENT_FULL_NAME: schedule.PATIENT_FULL_NAME
                    ? schedule.PATIENT_FULL_NAME
                    : `${schedule.PATIENT_FIRST_NAME} ${schedule.PATIENT_LAST_NAME}`, PATIENT_DOB: this.normalizeDob(patientDob), TIME: schedule.TIME
                    ? scheduleTimeIsValid
                        ? schedule.TIME
                        : this.correctTimeMeridiem(this.normalizeTime(schedule.TIME))
                    : timeIsValid
                        ? time
                        : this.correctTimeMeridiem(this.normalizeTime(time)), DATE: schedule.DATE ? this.normalizeDate(schedule.DATE) : date, PROVIDER_FIRST_NAME: schedule.PROVIDER_FIRST_NAME
                    ? schedule.PROVIDER_FIRST_NAME
                    : providerFirstName.replace(/[^A-Za-z]/, ""), PROVIDER_LAST_NAME: schedule.PROVIDER_LAST_NAME
                    ? schedule.PROVIDER_LAST_NAME
                    : providerLastName, PROVIDER_FULL_NAME: schedule.PROVIDER_FULL_NAME
                    ? schedule.PROVIDER_FULL_NAME
                    : `${schedule.PROVIDER_FIRST_NAME} ${schedule.PROVIDER_LAST_NAME}` });
        });
        this.normalizeDateTime = (date) => {
            if (!date) {
                return "";
            }
            const datetime = moment(date).format("M/D/YY h:mm A");
            datetime;
            if (datetime !== "Invalid date") {
                return datetime;
            }
            const re1 = /[APap]/;
            const matchFound1 = date.match(re1); /*?*/
            const re2 = /[Mm]/;
            const matchFound2 = date.match(re2); /*?*/
            if (matchFound1 && matchFound2) {
                const { index: startIndex } = matchFound1;
                const { index: endIndex } = matchFound2;
                const parsedTime = date.slice(0, matchFound1.index).trim(); /*?*/
                const parsedTimeMeridian = date
                    .slice(startIndex, endIndex + 1)
                    .toUpperCase()
                    .trim(); /*?*/
                const standardizedTime = `${parsedTime} ${parsedTimeMeridian}`; /*?*/
                const timeStandardized = moment(standardizedTime).format("M/D/YY h:mm: A");
                timeStandardized;
                return timeStandardized === "Invalid date" ? datetime : standardizedTime;
            }
            return datetime; // return "Invalid date"
        };
        this.normalizeDate = (date) => {
            const normalizedDate = moment(date, [
                "YYYY-MM-DD",
                "M/D/YYYY",
                "MM/DD/YYYY",
                "MM/D/YYYY",
                "YYYY-MM-DDH:mm:ss",
                "YYYY-MM-DDH:mm A",
                "YYYY-MM-DDH:mm:ss A"
            ]).format("M/D/YY");
            return normalizedDate === "Invalid date" ? date : normalizedDate;
        };
        this.normalizeDob = (date) => {
            if (!date) {
                return "";
            }
            const dateFormats = [
                "M/D/YY",
                "YYYY-MM-DD",
                "M/D/YYYY",
                "MM/D/YYYY",
                "MM/DD/YYYY",
                "YYYY-MM-DDH:mm A",
                "YYYY-MM-DDH:mm:ss",
                "YYYY-MM-DDH:mm:ss A"
            ];
            // Check for two digits format
            const twoDigitsFormat = "M/D/YY";
            const isTwoDigitsFormat = moment(date, twoDigitsFormat, true).isValid(); /*?*/
            const momentDate = moment(date, dateFormats);
            let normalizedDob = "";
            if (isTwoDigitsFormat) {
                normalizedDob = momentDate.isAfter()
                    ? momentDate.format("M/D/19YY")
                    : momentDate.format("M/D/YYYY");
            }
            else {
                if (momentDate.isValid()) {
                    normalizedDob = momentDate.format("M/D/YYYY");
                }
            }
            return normalizedDob;
        };
        this.normalizeTime = (time) => {
            const normalizedTime = moment(time, [
                "h:m A",
                "h:m a",
                "h:mm A",
                "h:mm a",
                "h:mma",
                "h:mmA",
                "YYYY-MM-DDH:mm:ss",
                "YYYY-MM-DDH:mm A",
                "YYYY-MM-DDH:mm:ss A"
            ]).format("h:mm A");
            // normalizedTime;
            // console.log('time is -------', time);
            // console.log('normalizedTime xx is ', normalizedTime);
            if (normalizedTime !== "Invalid date") {
                return normalizedTime;
            }
            const re1 = /[APap]/;
            const matchFound1 = time.match(re1); /*?*/
            const re2 = /[Mm]/;
            const matchFound2 = time.match(re2); /*?*/
            if (matchFound1 && matchFound2) {
                const { index: startIndex } = matchFound1;
                const { index: endIndex } = matchFound2;
                const parsedTime = time.slice(0, matchFound1.index); /*?*/
                const parsedTimeMeridian = time
                    .slice(startIndex, endIndex + 1)
                    .toUpperCase(); /*?*/
                const standardizedTime = `${parsedTime} ${parsedTimeMeridian}`; /*?*/
                // console.log('parsedTime is', parsedTime);
                // console.log('parsedTimeMerdian is', parsedTimeMeridian);
                // console.log('standardizedTime ', standardizedTime);
                const timeStandardized = moment(standardizedTime, "h:mm A").format("h:mm A");
                timeStandardized; /*?*/
                // console.log('timeStandardized is ', timeStandardized);
                if (timeStandardized === "Invalid date") {
                    return normalizedTime; // return Invalid date
                }
                return timeStandardized; // return hh:mm A
            }
            return time;
        };
        // Monitors state of clicked claims for printing purposes
        this.addPrintClaim = (claim) => {
            if (!this.selectedClaims.includes(claim)) {
                this.selectedClaims.push(claim);
            }
            else {
                const claimIndex = this.selectedClaims.indexOf(claim);
                this.selectedClaims.splice(claimIndex, 1);
            }
        };
        this.reset = () => {
            this.submissionInProgress = false;
            this.submission = {};
            this.submitted = false;
        };
        this.setSubmissionInProgress = (sip) => {
            this.submissionInProgress = sip;
        };
        this.setSiteSelected = (siteSelected) => {
            this.siteSelected = siteSelected;
        };
        // C-045.1
        this.setClaimOrders = (claimOrders) => {
            if (claimOrders) {
                this.claimOrders = claimOrders;
                this.isClaim = true;
            }
        };
        // C-045.1
        this.setClaimOrdersStatus = (status) => {
            this.isClaim = status;
        };
        this.parse = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newOrder", file, file.name);
            });
            formData.append("siteId", siteId);
            const response = await api_1.OrderEndpoint.parse.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
            }
            else {
                this.submission = { value: response.orders };
                // this.submissionQueueLength = this.submission.value.length;
            }
        };
        this.listClaimsWithinDateRange = async (query = { siteId: [0] }) => {
            const response = await api_1.OrderEndpoint.listwithindaterange.apiCall({ query });
            if (api_1.isError(response)) {
                console.error("Error in listing claims within date range.");
            }
            else {
                this.financialClaims = response.claims;
            }
        };
        this.listDispensedClaimsWithinDateRange = async (query = { siteId: [0], payPeriod: dashboard_1.PayPeriod.Daily }) => {
            query.dispensedOnly = true;
            const response = await api_1.OrderEndpoint.listwithindaterange.apiCall({ query });
            if (api_1.isError(response)) {
                console.error("Error in listing claims within date range.");
            }
            else {
                this.financialClaimsDispensed = response.claims;
            }
        };
        this.runPendingClaims = async (orders) => {
            const response = await api_1.OrderEndpoint.runPendingClaims.apiCall(null, {
                orders
            });
            if (api_1.isError(response)) {
                // Please update this to real error handling.
                return false;
            }
            return true;
        };
        this.stepBack = async (orderId) => {
            const response = await api_1.OrderEndpoint.stepBack.apiCall(null, { orderId });
            if (api_1.isError(response)) {
                // Please update this to real error handling.
                return false;
            }
            return true;
        };
        this.setReverse = async (orders, type) => {
            const response = await api_1.OrderEndpoint.setReverse.apiCall(null, {
                orders,
                type
            });
            if (api_1.isError(response)) {
                // Please update this to real error handling.
                return false;
            }
            return true;
        };
        this.listErxDataFields = async () => {
            var _a;
            if (Object.keys(this.erxDataFieldMap).length === 0) {
                const response = await api_1.OrderEndpoint.listerxdatafield.apiCall();
                if (api_1.isError(response)) {
                    console.log("Error in listing erx data fields", response.code);
                    this.erxDataFieldMap = {};
                }
                else {
                    (_a = response === null || response === void 0 ? void 0 : response.erxDataFields) === null || _a === void 0 ? void 0 : _a.forEach(field => {
                        const { dataField, rawValue, parsedValue } = field;
                        if (this.erxDataFieldMap[dataField] === undefined) {
                            this.erxDataFieldMap[dataField] = {};
                        }
                        this.erxDataFieldMap[dataField][rawValue] = parsedValue;
                    });
                }
            }
        };
        this.getQueueCount = async () => {
            const response = await api_1.OrderEndpoint.getqueue.apiCall(null, {});
            if (api_1.isError(response)) {
                return false;
            }
            this.submissionQueueLength = response.count;
            return null;
        };
        this.parseMappedSchedule = async (mappedSchedules, siteId, editSubmission, isNewPatient, providerId, skipAuditLog) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            // C-100
            const filteredMappedSchedules = mappedSchedules.map(row => {
                if (row[10].startsWith("+1") || row[10].startsWith("1")) {
                    row[10].startsWith("1") ? row[10] = row[10].slice(1) : row[10] = row[10].slice(2);
                }
                return row;
            });
            console.log("maplogic====>", filteredMappedSchedules);
            formData.append("mappedSchedules", JSON.stringify(filteredMappedSchedules));
            formData.append("siteId", String(siteId));
            if (editSubmission) {
                formData.append("editSubmission", JSON.stringify(editSubmission));
            }
            if (isNewPatient) {
                formData.append("isNewPatient", JSON.stringify(isNewPatient));
            }
            formData.append("providerId", JSON.stringify(providerId));
            if (skipAuditLog) {
                formData.append("skipAuditLog", "true");
            }
            const response = await api_1.OrderEndpoint.parseMappedSchedule.apiCall(null, formData);
            if (api_1.isError(response)) {
                alert(`ERROR: ${response.code}`);
                console.log("error in pasrmapschedule ", response);
                this.submission = { error: response.code };
            }
            else {
                if (editSubmission) {
                    const startIndex = 1;
                    const deleteCount = 1;
                    const insertItem = response && response.orders && response.orders[0];
                    const updatedSubmission = [...this.submission.value];
                    updatedSubmission.splice(startIndex, deleteCount, insertItem);
                    if (insertItem) {
                        this.submission = { value: updatedSubmission };
                    }
                    else {
                        alert("Single patient submission did not return");
                    }
                }
                else {
                    this.submission = { value: response.orders };
                }
            }
        };
        this.buildPatientSchedule = async (patientId, siteId, submission) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            // const result = OrderEndpoint.buildpatientschedule(patientid, siteId);
            const result = await api_1.OrderEndpoint.buildpatientschedule.apiCall(null, {
                patientId,
                siteId,
                submission
            });
            if (api_1.isError(result)) {
                throw Error("error in parsing");
            }
            else {
                if (result.orders.length) {
                    const patientSchedule = result.orders[0];
                    const patient = patientSchedule ? patientSchedule.patient : null;
                    if (patient) {
                        // loop through this.submissions and find patient to patient object to override.
                        if (this.submission.value) {
                            this.submission.value.forEach((patientObject) => {
                                if (patientObject &&
                                    patientObject.patient &&
                                    patientObject.id === patientSchedule.id) {
                                    alert("in");
                                    // console.log("****************", patientObject);
                                    patientObject.patient = Object.assign(Object.assign({}, patientObject.patient), patient);
                                }
                            });
                            this.submission = {
                                value: this.submission.value
                            };
                        }
                        // break line
                    }
                }
            }
        };
        this.parseImportsHeader = async (files, siteId) => {
            console.count("parseImportHeader");
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newOrder", file, file.name);
            });
            formData.append("siteId", siteId);
            const response = await api_1.OrderEndpoint.parseColumnsHeader.apiCall(null, formData);
            // console.log("response ssdfdffd is ", response);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                console.log("error  ---------");
                throw Error("error in parsing");
            }
            else {
                console.log("response is ", response);
                let parsedRows;
                if (response &&
                    response.parsedRows &&
                    response.parsedRows.length &&
                    response.parsedRows[0].lines) {
                    parsedRows = [response.parsedRows[0].lines];
                    this.scheduleDateFromRtf = response.parsedRows[0].scheduleDate;
                }
                else {
                    this.scheduleDateFromRtf = "";
                    parsedRows = response.parsedRows;
                }
                // this.parsedRows = response.parsedRows; // #TK the parsedRows from parsing csv
                this.parsedRows = parsedRows; // #TK the parsedRows from parsing csv
            }
        };
        this.submit = async (siteId, checkedIds) => {
            console.log("inside ordersstore submit siteId is ", siteId);
            console.log("inside ordersstore submit checkedIds is ", checkedIds);
            this.submission = { loading: true, value: this.submission.value };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            let submissions = this.validSubmissions;
            if (checkedIds) {
                submissions = this.validSubmissions.filter(submission => checkedIds[submission.id] === true);
            }
            const slimSubmissions = submissions.map(submission => ({
                patientId: submission.patient.id,
                providerId: submission.provider.id,
                payment: submission.payment,
                date: submission.date,
                time: submission.time
            }));
            const response = await api_1.OrderEndpoint.submit.apiCall(null, {
                orders: slimSubmissions,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
                console.error("error ocurred in submitting patient orders", response.code);
                console.error("this submission is ", this.submission);
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                // console.log("no errors --- this submissionn is ", this.submission);
            }
        };
        // C-097 Claims
        this.loadOrders = async (query = { page: 1, limit: 100 }, showLoading = false) => {
            // C-110 set limit to 100
            if (showLoading) {
                this.orders = { loading: true, value: this.orders.value }; // C-097 for pagination added this loading: true,
            }
            if (!showLoading && query.page == 1) {
                this.orders = { loading: true, value: this.orders.value }; // C-097 for pagination added this loading: true,
            }
            const result = await api_1.OrderEndpoint.list.apiCall({
                query
            });
            // console.log('loadorder results: ', result);
            if (api_1.isError(result)) {
                this.orders = { loading: false, error: result.code }; // C-097 for pagination added this loading: false,
            }
            else {
                this.orders = { loading: false, value: result.orders }; // C-097 for pagination added this loading: false,
                this.totalProviderPage = result.totalPages; // for pagination // C-097
                this.currentPage = result.currentPage; // for pagination   // C-097 
            }
        };
        this.loadpendingPayableOrders = async (query = { page: 1, limit: 100 }, showLoading = false) => {
            const requestId = ++this.pendingPayableRequestId;
            if (showLoading) {
                this.pendingOrders = { loading: true, value: this.pendingOrders.value };
            }
            if (!showLoading && query.page == 1) {
                this.pendingOrders = { loading: true, value: this.pendingOrders.value }; // C-097 for pagination added this loading: true,
            }
            const result = await api_1.OrderEndpoint.pendingPayablelist.apiCall({
                query
            });
            if (requestId !== this.pendingPayableRequestId) {
                return;
            }
            if (api_1.isError(result)) {
                this.pendingOrders = {
                    loading: false,
                    error: result.code,
                    value: this.pendingOrders.value
                };
            }
            else {
                this.pendingOrders = { loading: false, value: result.orders };
                this.pendingCurrentPage = result.currentPage;
                this.totalPendingPage = result.totalPages;
            }
        };
        /**
         * B-106 handle bulk orders API
         * @param query
         * @param showLoading
         */
        this.loadBulkOrders = async (query, showLoading = false) => {
            if (showLoading) {
                this.bulkOrders = { loading: true, value: this.bulkOrders.value };
            }
            const result = await api_1.OrderEndpoint.listBulkOrders.apiCall({ query });
            if (api_1.isError(result)) {
                this.bulkOrders = { error: result.code };
            }
            else {
                this.bulkOrders = { value: result.bulkOrders };
            }
        };
        this.addQueue = async (siteId, submissions) => {
            const result = await api_1.OrderEndpoint.addQueue.apiCall(null, {
                siteId,
                submissions
            });
        };
        this.updateQueue = async (queueId, data) => {
            const result = await api_1.OrderEndpoint.updateQueue.apiCall(null, {
                queueId,
                data
            });
        };
        this.deleteQueue = async (queueIds) => {
            console.log("queueIds is ", queueIds);
            const result = await api_1.OrderEndpoint.deleteQueue.apiCall(null, { queueIds });
        };
        // C-097 Queued Appointments
        // @action public readQueue = async (query: {siteId: number;order: "ASC" | "DESC";orderBy: string;}) => {
        this.readQueue = async (query) => {
            this.claimsLoading = true;
            const result = await api_1.OrderEndpoint.readQueue.apiCall({ query });
            if (api_1.isError(result)) {
                return result.code;
            }
            this.totalProviderPage = result.totalPages; // C-097 Queued Appointment    
            this.currentPage = result.currentPage; // C-097 Queued Appointment 
            this.claimsLoading = false; // C-097 Queued Appointment
            return result.result;
        };
        this.readQueueRow = async (rowId) => {
            const result = await api_1.OrderEndpoint.readQueueRow.apiCall(null, { rowId });
            if (api_1.isError(result)) {
                return result.code;
            }
            return result.result;
        };
        this.readOrder = async (id, reload) => {
            if (reload) {
                this.order = { loading: true, value: this.order.value };
            }
            else {
                this.order = { loading: true };
            }
            const result = await api_1.OrderEndpoint.read.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                this.order = { error: result.code };
            }
            else {
                this.order = { value: result.order };
            }
        };
        /** D-002.810 — single refresh for order header payment-due status (claims + payments). */
        this.refreshOrderDetail = async (orderId, reload = false) => {
            // Prefer reload=true on readOrder so we never clear order.value mid-refresh
            // (that made isPaymentComplete briefly/falsely report "Patient Payment Due").
            await this.loadClaims(orderId, undefined, reload, true);
            await this.readOrder(orderId, true);
        };
        this.dispenseOrder = async (order, undo = false, reason = null) => {
            this.claimsGroup = { loading: true, value: this.claimsGroup.value };
            this.order.loading = true;
            const result = await api_1.OrderEndpoint.dispense.apiCall(null, {
                order: undo ? { claims: order.claims, id: order.id } : order,
                reason,
                undo
            });
            if (api_1.isError(result)) {
                this.claimsGroup = { error: result.code, value: this.claimsGroup.value };
                return false;
            }
            this.order = { loading: false, value: result.order };
            this.claimsGroup = { value: this.claimsGroup.value };
            return true;
        };
        // C-108.7
        this.signatureBypass = async (claims, reason) => {
            const result = await api_1.OrderEndpoint.signatureBypass.apiCall(null, {
                claims: claims ? claims : [],
                reason
            });
            if (api_1.isError(result)) {
                return false;
            }
            return true;
        };
        this.countOrder = async (query) => {
            this.count.loading = true;
            const result = await api_1.OrderEndpoint.count.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.count = { error: result.code, value: this.count.value };
            }
            else {
                this.count = { loading: true, value: result.count };
            }
        };
        this.updateSignatures = async (claimIds, signature) => {
            const result = await api_1.OrderEndpoint.updateSignatures.apiCall(null, { claimIds, signature });
            return result;
        };
        this.updateStatusAsPaid = async (orderId, claimId) => {
            const result = await api_1.OrderEndpoint.updatestatusaspaid.apiCall(null, {
                orderId,
                claimId
            });
            if (api_1.isError(result)) {
                console.error("Error updating status as paid", result);
            }
            else {
                console.log("Successfully updated status as paid");
            }
        };
        this.cancelIntentClaim = async (claim) => {
            const result = await api_1.OrderEndpoint.cancelintentclaim.apiCall(null, {
                claim
            });
            if (api_1.isError(result)) {
                console.log(result.code);
            }
            console.info("result from cancelIntentClaim is", result);
            // if (isError(result)) {
            //   this.claimsGroup = { error: result.code, value: this.claimsGroup.value };
            //   return false;
            // }
            // this.order = { value: result.order };
            // this.claimsGroup = { value: this.claimsGroup.value };
            // return true;
        };
        this.loadReadyToDispense = async () => {
            const result = await api_1.OrderEndpoint.loadReadyToDispense.apiCall(null, null);
            if (api_1.isError(result)) {
                return null;
            }
            return { orders: result.orders, provider: result.provider };
        };
        this.loadPrescribe = async () => {
            const result = await api_1.OrderEndpoint.loadPrescribe.apiCall(null, null);
            if (api_1.isError(result)) {
                return null;
            }
            return { orders: result.orders, provider: result.provider };
        };
        this.updatePrescribe = async (claimId) => {
            const result = await api_1.OrderEndpoint.updatePrescribe.apiCall(null, {
                claimId
            });
            if (api_1.isError(result)) {
                return false;
            }
            return true;
        };
        this.updateAuditStatus = async (orderId) => {
            const result = await api_1.OrderEndpoint.updateAuditStatus.apiCall(null, {
                orderId
            });
            if (api_1.isError(result)) {
                return false;
            }
            return true;
        };
        this.undoDispense = async (claim) => {
            const result = await api_1.OrderEndpoint.undoDispense.apiCall(null, { claim });
            if (api_1.isError(result)) {
                console.log(result.code);
            }
            // if (isError(result)) {
            //   this.claimsGroup = { error: result.code, value: this.claimsGroup.value };
            //   return false;
            // }
            // this.order = { value: result.order };
            // this.claimsGroup = { value: this.claimsGroup.value };
            // return true;
        };
        this.loadIntentClaims = async (query = { start: 0, count: 200 }) => {
            const result = await api_1.OrderEndpoint.listintentclaims.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.intentClaims = { error: result.code };
            }
            else {
                this.intentClaims = { value: result.claims };
            }
        };
        this.loadClaims = async (orderId, query = { start: 0, count: 200 }, reload = false, ordersDetail = false) => {
            var _a, _b;
            this.claimsGroup = reload
                ? { loading: true, value: this.claimsGroup.value }
                : { loading: true };
            const options = { ordersDetail };
            const result = await api_1.OrderEndpoint.listClaims.apiCall({
                params: { id: orderId },
                query
            }, { options });
            if (api_1.isError(result)) {
                this.claimsGroup = { error: result.code };
            }
            else {
                this.claimsGroup = { value: result.claimsGroup };
                if (result.orderData) {
                    // D-002.810 — if orderData omitted claim.payments, keep prior payments so
                    // header status does not flip back to "Patient Payment Due" on tab switch.
                    const previousClaims = ((_b = (_a = this.order) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.claims) || [];
                    const nextClaims = result.orderData.claims || [];
                    const paymentsByClaimId = new Map(previousClaims.map((claim) => [claim.id, claim.payments]));
                    for (const claim of nextClaims) {
                        // Only backfill when payments were not loaded (undefined/null), not when [].
                        if (claim.payments == null) {
                            claim.payments = paymentsByClaimId.get(claim.id) || [];
                        }
                    }
                    this.order = { value: result.orderData };
                }
            }
        };
        /**
         * @author tkay
         * @desc load claims within date interval.
         */
        this.loadClaimsInterval = async (audit) => {
            const result = await api_1.OrderEndpoint.listClaimsInterval.apiCall(null, {
                audit
            });
            if (api_1.isError(result)) {
                throw new Error("error in loading claims interval");
            }
            else {
                return result;
            }
        };
        this.saveCounsel = async (orderId, value) => {
            const result = await api_1.OrderEndpoint.saveCounsel.apiCall(null, {
                orderId,
                value
            });
            if (api_1.isError(result)) {
                throw new Error("Couldn't save counsel.");
            }
            else {
                return result;
            }
        };
        this.getClaimId = async (orderId, rxId) => {
            const result = await api_1.OrderEndpoint.getclaimid.apiCall({
                query: { orderId, rxId }
            });
            if (api_1.isError(result)) {
                console.error("Error getClaimId", result);
                return null;
            }
            else {
                return result.claimId;
            }
        };
        this.readClaim = async (claimId, query = { start: 0, count: 200 }) => {
            this.claim.loading = true;
            const result = await api_1.OrderEndpoint.readClaim.apiCall({
                params: { id: claimId }
            });
            if (api_1.isError(result)) {
                this.claim = { error: result.code };
                return false;
            }
            else {
                this.claim = { value: result.claim };
                return result.claim;
            }
        };
        this.readUpdatedClaim = async (claimId) => {
            const result = await api_1.OrderEndpoint.readupdatedclaim.apiCall({
                params: { id: claimId }
            });
            if (api_1.isError(result)) {
                console.log("error in reading updated claim for new claim lots", result);
                return false;
            }
            return result.claim;
        };
        this.retryClaim = async (claimId) => {
            // console.log("claimId", claimId);
            this.order = { loading: true, value: this.order.value };
            const result = await api_1.OrderEndpoint.retryClaim.apiCall({
                params: { id: claimId }
            });
            if (api_1.isError(result)) {
                this.order = { error: result.code, value: this.order.value };
            }
            else {
                if (this.order.value) {
                    this.loadClaims(this.order.value.id, undefined, true);
                    this.readOrder(this.order.value.id);
                }
            }
        };
        this.refillClaim = async (claimId, claimType = 0, insuranceId = null) => {
            // claimType 0 means insurance
            // claimType 1 means cash
            this.order = { loading: true, value: this.order.value };
            const result = await api_1.OrderEndpoint.refillClaim.apiCall({
                params: { id: claimId }
            }, { type: claimType, insuranceId });
            if (api_1.isError(result)) {
                this.order = { error: result.code, value: this.order.value };
                return false;
            }
            else {
                if (this.order.value) {
                    this.loadClaims(this.order.value.id, undefined, true);
                    this.readOrder(this.order.value.id);
                }
                return result.order;
            }
        };
        this.updateClaim = async (claim) => {
            // console.log("claim is ", claim);
            const result = await api_1.OrderEndpoint.updateClaim.apiCall(null, { claim });
            if (!api_1.isError(result)) {
                return result;
            }
        };
        this.updateClaimDispenseScan = async (claim, lots, siteId) => {
            const result = await api_1.OrderEndpoint.updateClaimDispenseScan.apiCall(null, {
                claim,
                lots,
                siteId
            });
            if (api_1.isError(result)) {
                console.error("Error in updateClaimDispenseScan", result);
            }
        };
        this.delayRefillClaim = async (claimId) => {
            this.order = { loading: true, value: this.order.value };
            const result = await api_1.OrderEndpoint.delayRefillClaim.apiCall({
                params: { id: claimId }
            });
            if (api_1.isError(result)) {
                this.order = { error: result.code, value: this.order.value };
            }
            else {
                if (this.order.value) {
                    this.loadClaims(this.order.value.id, undefined, true);
                    this.readOrder(this.order.value.id);
                }
            }
        };
        this.cancelRefillClaim = async (claimId) => {
            this.order = { loading: true, value: this.order.value };
            const result = await api_1.OrderEndpoint.cancelRefillClaim.apiCall({
                params: { id: claimId }
            });
            if (api_1.isError(result)) {
                this.order = { error: result.code, value: this.order.value };
            }
            else {
                if (this.order.value) {
                    this.loadClaims(this.order.value.id, undefined, true);
                    this.readOrder(this.order.value.id);
                }
            }
        };
        this.loadActivePads = async (order) => {
            const siteId = order.site.id;
            if (siteId === undefined)
                return;
            this.pads = { loading: true, value: this.pads.value };
            const result = await api_1.PadEndpoint.listactive.apiCall({
                params: { siteId: [siteId] }
            });
            if (api_1.isError(result)) {
                this.pads = { error: result.code };
            }
            else {
                this.pads = { value: result.pads };
            }
        };
        this.loadActiveMobilePads = async (order) => {
            const siteId = order.site.id;
            if (siteId === undefined)
                return;
            this.mobilePads = { loading: true, value: this.mobilePads.value };
            const result = await api_1.PadEndpoint.listactivemobile.apiCall({
                params: { siteId: [siteId] }
            });
            if (api_1.isError(result)) {
                this.mobilePads = { error: result.code };
            }
            else {
                this.mobilePads = { value: result.pads };
            }
            console.log('this.mobilePads', this.mobilePads);
        };
        this.promptSignature = async (pad, claims, order, bill) => {
            var _a;
            if (order.site.id === undefined)
                return;
            this.pads = { loading: true, value: this.pads.value };
            let result;
            if (!bill) {
                result = await api_1.PadEndpoint.promptSignature.apiCall(null, {
                    pad,
                    type: "claim",
                    id: (_a = claims[0].id) !== null && _a !== void 0 ? _a : claims[0],
                    claims
                });
            }
            else {
                result = await api_1.PadEndpoint.promptSignature.apiCall(null, {
                    pad,
                    type: "order",
                    id: order.id
                });
            }
            if (api_1.isError(result)) {
                this.pads = { error: result.code };
            }
            else {
                this.pads = { value: this.pads.value };
            }
        };
        this.promptMobileSignature = async (pad, claims, order) => {
            if (order.site.id === undefined)
                return;
            this.pads = { loading: true, value: this.pads.value };
            let result;
            result = await api_1.PadEndpoint.promptMobileSignature.apiCall(null, {
                pad: pad,
                type: "claim",
                order_id: order.id,
                selectedClaims: claims,
            });
            if (api_1.isError(result)) {
                this.mobilePads = { error: result.code };
            }
            else {
                this.mobilePads = { value: this.mobilePads.value };
            }
        };
        this.createOrder = async (siteId, providerId, patientId, insuranceId, inventory, orderType, runAt, bypassAutomation = false, altInsurances) => {
            const result = await api_1.OrderEndpoint.createOrder.apiCall(null, {
                siteId,
                providerId,
                patientId,
                insuranceId,
                inventory,
                orderType,
                runAt,
                bypassAutomation,
                altInsurances
            });
            console.log("result from createOrder is ", result);
            if (api_1.isError(result)) {
                this.order = { error: result.code };
                return false;
            }
            else {
                this.order = { value: result.order };
                return { order: result.order };
            }
        };
        this.updateOrder = async (order) => {
            const result = await api_1.OrderEndpoint.updateOrder.apiCall(null, { order });
        };
        this.savePDFToServer = async (claim, parsedMonograph, barcode, providerSig, patientSig, currentUser) => {
            await api_1.OrderEndpoint.savePDFToServer.apiCall(null, {
                claim,
                parsedMonograph,
                barcode,
                providerSig,
                patientSig,
                currentUser
            });
        };
        this.print = async (claims, type) => {
            const labelStack = await print_labels_1.labelsManager.generateLabelStack(claims, type);
            await this.printLabels(labelStack, type);
        };
        //D-002.611 used to send a attachment of pdf file in mail
        this.receiptPdfFile = async (claims, type, query) => {
            const labelStack = await print_labels_1.labelsManager.generateLabelStack(claims, type);
            this.pdfPreview = null; // Reset if we're trying to print again.
            const printMetas = await Promise.all(print_labels_1.labelsManager.generatePrintMeta(labelStack, type));
            if (type === "saveToDB")
                return; // No need to render outside of DB.
            const pdfStack = print_labels_1.printManager.initiatePrint(printMetas);
            // @ts-ignore - pdfMake is mounted on the Window object by a <script> tag in index.html
            window.pdfMake.createPdf(pdfStack).getBase64(async function (encodedString) {
                query.receiptPdfFile = encodedString;
                await store_1.paymentsStore.sendPaymentReceipt(query);
            });
        };
        this.printLabels = async (labelStack, type) => {
            this.pdfPreview = null; // Reset if we're trying to print again.
            const printMetas = await Promise.all(print_labels_1.labelsManager.generatePrintMeta(labelStack, type));
            if (type === "saveToDB")
                return; // No need to render outside of DB.
            const pdfStack = print_labels_1.printManager.initiatePrint(printMetas);
            const pdf = window.pdfMake.createPdf(pdfStack);
            if (window.location.href.includes("print-labels"))
                pdf.open(); // Only open on print page
            pdf.getDataUrl((dataUrl) => (this.pdfPreview = dataUrl));
        };
        this.updateProvider = async (orders, providerId) => {
            const response = await api_1.OrderEndpoint.updateProvider.apiCall(null, {
                orders,
                providerId
            });
            if (api_1.isError(response)) {
                // Please update this to real error handling.
                return false;
            }
            return true;
        };
        this.loadTransactionData = async (claimId) => {
            const response = await api_1.OrderEndpoint.readTransactionData.apiCall({ query: { claimId } });
            if (api_1.isError(response)) {
                // Please update this to real error handling.
                return false;
            }
            return response.data;
        };
    }
    get paymentLabel() {
        if (this.paymentToggle === false) {
            return "Show Cash Paid Claims";
        }
        else {
            return "Show Insurance Paid Claims";
        }
    }
    get paymentTitle() {
        return `Claims: ${!this.paymentToggle ? "Insurance" : "Cash"}`;
    }
    get validSubmissions() {
        return this.submission.value
            ? this.submission.value.filter(submission => submission.status === order_1.SubmissionStatus.Valid)
            : [];
    }
}
__decorate([
    mobx_1.computed
], OrdersStore.prototype, "paymentLabel", null);
__decorate([
    mobx_1.computed
], OrdersStore.prototype, "paymentTitle", null);
__decorate([
    mobx_1.computed
], OrdersStore.prototype, "validSubmissions", null);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "erxDataFieldMap", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "count", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "orders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "pendingOrders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "bulkOrders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "pads", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "mobilePads", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "showCompleted", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "paymentToggle", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "submissionQueueLength", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "submissionInProgress", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "siteSelected", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "claimsGroup", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "signatureBypassed", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "intentClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "claim", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "financialClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "financialClaimsDispensed", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "importedOrders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "dbHeaders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "importedFileAndSiteId", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "errorAlert", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "sampleFirstDataRow", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "sampleFirst5DataRows", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "selectedClaims", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "pdfPreview", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "menuOpen", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "patientSchedulesAndSite", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "scheduleDateFromRtf", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "selectedSiteId", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "userViewCount", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "selectedProviderId", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "submitAutomation", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "fileFormat", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "claimOrders", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "isClaim", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "claimsLoading", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "shouldAutomateSubmission", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "totalPendingPage", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "pendingCurrentPage", void 0);
__decorate([
    mobx_1.observable
], OrdersStore.prototype, "knownHeaderFormats", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readERXLog", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "fillInMissingData", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "normalizeDateTime", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "normalizeDate", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "normalizeDob", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "normalizeTime", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "addPrintClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "reset", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "setSubmissionInProgress", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "setSiteSelected", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "setClaimOrders", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "setClaimOrdersStatus", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "parse", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "listClaimsWithinDateRange", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "listDispensedClaimsWithinDateRange", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "runPendingClaims", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "stepBack", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "setReverse", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "listErxDataFields", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "getQueueCount", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "parseMappedSchedule", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "buildPatientSchedule", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "parseImportsHeader", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "submit", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadOrders", void 0);
__decorate([
    mobx_1.action //D-002_new
], OrdersStore.prototype, "loadpendingPayableOrders", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadBulkOrders", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "addQueue", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateQueue", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "deleteQueue", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readQueue", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readQueueRow", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readOrder", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "refreshOrderDetail", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "dispenseOrder", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "signatureBypass", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "countOrder", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateSignatures", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateStatusAsPaid", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "cancelIntentClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadReadyToDispense", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadPrescribe", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updatePrescribe", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateAuditStatus", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "undoDispense", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadIntentClaims", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadClaims", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadClaimsInterval", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "saveCounsel", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "getClaimId", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "readUpdatedClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "retryClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "refillClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateClaimDispenseScan", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "delayRefillClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "cancelRefillClaim", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadActivePads", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "loadActiveMobilePads", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "promptSignature", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "promptMobileSignature", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "createOrder", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "updateOrder", void 0);
__decorate([
    mobx_1.action
], OrdersStore.prototype, "savePDFToServer", void 0);
exports.ordersStore = new OrdersStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/store.ts
// module id = 70
// module chunks = 0 1